export const onGettedAssetLocationInfo = response => {
    const asset = response?.data?.asset
    return {
        serviceLocationId: asset?.serviceLocation?.external_id || null,
        shipToAccountId: asset?.shipto?.external_id || null,
    }
}
